import React, { Component } from 'react'
import './PurchaseForm.css'
import ButtonForm from '../../Layouts/Layouts_PurchaseForm/ButtonForm/ButtonForm'
import InputForm from '../../Layouts/Layouts_PurchaseForm/InputForm/InputForm'
import PackSelector, { PackSelectorSummaryTable } from '../../Layouts/Layouts_PurchaseForm/PackSelector/PackSelector'
import Loader from '../../Global_Layouts/Loader/Loader'
import { generateFirebaseId } from '../../Helpers/generateAFirebaseId'
import ScrollDownArrow from '../../Global_Layouts/ScrollDownArrow/ScrollDownArrow'
import DiscountCode from '../../Layouts/Layouts_PurchaseForm/DiscountCode/DiscountCode'
import TiktokPixel from 'tiktok-pixel'
import { ShoppingCartWidget } from '../../App'
import ShippingTypeSelector from '../../Layouts/Layouts_PurchaseForm/ShippingTypeSelector/ShippingTypeSelector'
// import { ShoppingCartWidget } from '../Collection/Collection'

export default class PurchaseForm extends Component {

  state={
    fillingForm: null,
  }

  componentDidMount=()=>{
    window.fbq('track', 'InitiateCheckout');
    TiktokPixel.track('InitiateCheckout', {
      content_type: 'product', 
      content_id: 'ID_del_producto',
      currency: 'COP',
      value: 139900,
      content_name: 'Nombre_del_producto',
      quantity: 1,
    });
    
    window.checkoutId = generateFirebaseId(); // console.log(window.checkoutId)
    const modalContainer = document.querySelector('.pure-modal .panel-body');
    modalContainer.scrollTop = 0;
    modalContainer.addEventListener('scroll', () => {
      const elementPosition = document?.getElementById('middle_start')?.getBoundingClientRect()?? null;
      if (elementPosition && (elementPosition.top <= modalContainer.clientHeight && elementPosition.bottom >= 0)) {
        this.setState({fillingForm: true})
      }
    });
    this.addToCart(null, null, true)
    if(this.props.setShowToast){
      this.props.setShowToast(false)
    }
  }

  goDown=()=>{
    document.getElementById("form_start").scrollIntoView({behavior: "smooth"})
    this.setState({fillingForm: true})
  }

  componentDidUpdate=(prevProps, prevState)=>{
    const {from_cart} = this.props
    const {ProductData, selectedPackData, selectedVariants} = this.props
    if(from_cart!==true){
      if(prevProps.selectedVariants !== selectedVariants){
        this.addToCart(null, selectedVariants)
      }
      if(prevProps.selectedPackData.quantity !== selectedPackData.quantity){
        this.addToCart(selectedPackData, null)
      }
    }
  }

  addToCart = (selectedPackDataAux, selectedVariantsAux, isInitialized) => {
    const { ProductData, selectedPackData, selectedVariants } = this.props;
    const { cart_items, add_to_cart, remove_from_cart } = this.props;
    if (ProductData){
      const itemIndex = cart_items.findIndex(item => item?.ProductData?.product_inside_id === ProductData?.product_inside_id);
      if (itemIndex !== -1) {
        let updatedItem = null
        if (selectedPackDataAux) {
          updatedItem = {
            ...cart_items[itemIndex],
            selectedPackData: selectedPackDataAux,
          };
        } else if (selectedVariantsAux) {
          updatedItem = {
            ...cart_items[itemIndex],
            selectedVariants: selectedVariantsAux,
          };
        } else if (isInitialized){
          updatedItem = {
            ProductData,
            selectedPackData,
            selectedVariants,
            automatic_added: true
          };
        }
        add_to_cart(updatedItem, itemIndex);
      }
      else {
        add_to_cart({
          ProductData,
          selectedPackData,
          selectedVariants,
          automatic_added: true
        })
      }
    }
  }

  render() {
    const {createDraftOrder, selectedVariants, showLoader, ProductData, createOrder, readData, getSelectedPackData, getSelectedVariants, selectedPackId, selectedPackData,  quantity, discount_code, first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, shipping_type_code} = this.props
    const {cart_items, add_to_cart, remove_from_cart, from_cart } = this.props
    const {setDiscountValue, free_shipping, shipping_cost, bulk_unit_discount, units, min_qty_to_get_bulk_discount} = this.props
    
    if (showLoader === false) { 
      return (
        <div>
          {
            from_cart!==true?
            <PackSelector 
              cart_items={cart_items} 
              add_to_cart={add_to_cart} 
              remove_from_cart={remove_from_cart} 
              selectedVariants={selectedVariants} 
              getSelectedVariants={getSelectedVariants} 
              ProductData={ProductData} 
              getSelectedPackData={getSelectedPackData} 
              selectedPackId={selectedPackId} 
              selectedPackData={selectedPackData}
            />
            :
            null
          }
          <DiscountCode setDiscountValue={setDiscountValue} onChange={readData} discount_code={discount_code} selectedPackData={selectedPackData}/>
          <form onSubmit={createOrder}>
            {/* <div className='PurchaseForm_title'>Selecciona una promocion</div> */}
            
            <div id='form_start' className='PurchaseForm_title'>Por favor completa el formulario para terminar tu compra</div>
            <InputForm onBlur={()=>this.setState({fillingForm: true})} input_required={true} input_value={first_name} input_type={"text"} with_label_text={true} label_text={"Nombres *"} label_htmlFor={"first_name"} with_small_text={false} small_text={null} input_id={"first_name"} input_placeholder={"Nombres"} onChange={readData}/>
            <InputForm input_required={true} input_value={last_name} input_type={"text"} with_label_text={true} label_text={"Apellidos *"} label_htmlFor={"last_name"} with_small_text={false} small_text={null} input_id={"last_name"} input_placeholder={"Apellidos"} onChange={readData}/>
            <InputForm onBlur={createDraftOrder} input_required={true} input_value={phone_number} input_type={"number"} with_label_text={true} label_text={"Celular *"} label_htmlFor={"phone_number"} with_small_text={false} small_text={null} input_id={"phone_number"} input_placeholder={"Celular (Preferiblemente con Whatsapp)"} onChange={readData}/>
            <InputForm input_required={true} input_value={address1} input_type={"text"} with_label_text={true} label_text={"Dirección de entrega *"} label_htmlFor={"address1"} with_small_text={false} small_text={null} input_id={"address1"} input_placeholder={"Dirección de entrega"} onChange={readData}/>
            <InputForm input_required={false} input_value={address2} input_type={"text"} with_label_text={true} label_text={"Indicaciones extra en la dirección (Opcional)"} label_htmlFor={"address2"} with_small_text={false} small_text={null} input_id={"address2"} input_placeholder={"Apto / Casa / Conjunto / Barrio (Opcional)"} onChange={readData}/>
            <InputForm input_required={true} input_value={province} input_type={"text"} with_label_text={true} label_text={"Departamento *"} label_htmlFor={"province"} with_small_text={false} small_text={null} input_id={"province"} input_placeholder={"Departamento"} onChange={readData}/>
            <InputForm onBlur={createDraftOrder} input_required={true} input_value={city} input_type={"text"} with_label_text={true} label_text={"Ciudad *"} label_htmlFor={"city"} with_small_text={false} small_text={null} input_id={"city"} input_placeholder={"Ciudad"} onChange={readData}/>
            <InputForm id={"middle_start"} input_required={false} input_value={contact_email} input_type={"email"} with_label_text={true} label_text={"Email"} label_htmlFor={"contact_email"} with_small_text={false} small_text={null} input_id={"contact_email"} input_placeholder={"Email"} onChange={readData}/>
            <InputForm input_required={false} input_value={note} input_type={"text"} with_label_text={true} label_text={"Nota adicional"} label_htmlFor={"note"} with_small_text={false} small_text={null} input_id={"note"} input_placeholder={"Confirmar talla, color, etc"} onChange={readData}/>
            <ShippingTypeSelector
              shipping_type_code={shipping_type_code} 
              onChange={readData} 
            />
            
            {
              cart_items?.length > 0?
              <ShoppingCartWidget units={units} from_purchase_form={true} cart_items={cart_items} add_to_cart={add_to_cart} remove_from_cart={remove_from_cart} />
              :
              null
            }

            <PackSelectorSummaryTable 
              min_qty_to_get_bulk_discount={min_qty_to_get_bulk_discount} free_shipping={free_shipping} shipping_cost={shipping_cost} bulk_unit_discount={bulk_unit_discount} units={units}
              selectedPackData={selectedPackData} cartItems={cart_items} shipping_type_code={shipping_type_code}
            />

            <div style={{marginTop:"70px"}}>
              <ButtonForm type={"submit"} button_text={"COMPRAR AHORA - PAGAR AL RECIBIR"} />
            </div>
                                                                                              
            {this.state.fillingForm !== true?
              <div className='sticky-footer'>
                {/* <ButtonForm onClick={this.goDown} type={""} button_text={"CONTINUAR"} /> */}
                <ScrollDownArrow onClick={this.goDown} />
              </div>
            :null}

          </form>
        </div>
        )
    }
    
    return (<Loader first_name={first_name} statusLabel={ "Creando" }/>)
  }
}
